// extracted by mini-css-extract-plugin
module.exports = {"overAll":"candidatedrawer_overAll__3MPBY","openStyle":"candidatedrawer_openStyle__2-d-E","border":"candidatedrawer_border__2nU5T","button":"candidatedrawer_button__8vtvM"};